module.exports = __webpack_public_path__ + "img/special-1.b5eba510.jpg";